import styled from "styled-components";

// TEXT

// STYLES
export const ModalFoot = styled.div`
  gap: 0.5rem;
  display: flex;
  padding: 2rem 1.5rem 0;
  justify-content: flex-end;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
